(function () {
  const endpointBase = 'https://a.klaviyo.com/client/subscriptions/';

  function setMessage(form, text, isError) {
    const message = form.querySelector('[data-fp-klaviyo-message]');
    if (!message) return;
    message.hidden = false;
    message.textContent = text;
    message.classList.toggle('fp-home-footer__error', Boolean(isError));
    message.classList.toggle('fp-home-footer__message', !isError);
  }

  function nativeFallback(form) {
    form.dataset.fpKlaviyoBypass = 'true';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  async function subscribe(form) {
    const companyId = form.dataset.klaviyoCompanyId;
    const listId = form.dataset.klaviyoListId;
    const source = form.dataset.klaviyoSource || 'Footer newsletter FridaPets';
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const consentInput = form.querySelector('input[name="contact[accepts_marketing]"]');
    const submit = form.querySelector('button[type="submit"]');
    const email = emailInput ? emailInput.value.trim() : '';

    if (!companyId || !listId || !email) {
      nativeFallback(form);
      return;
    }

    if (submit) submit.disabled = true;
    setMessage(form, 'Registrando tu correo...', false);

    const response = await fetch(`${endpointBase}?company_id=${encodeURIComponent(companyId)}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        revision: '2024-06-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: consentInput && consentInput.checked ? 'SUBSCRIBED' : 'NEVER_SUBSCRIBED'
                      }
                    }
                  },
                  properties: {
                    fuente_registro: source,
                    canal_registro: 'footer',
                    sitio: window.location.hostname
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      })
    });

    if (!response.ok) {
      throw new Error(`Klaviyo subscription failed: ${response.status}`);
    }

    form.reset();
    setMessage(form, 'Listo. Te agregamos a las novedades de FridaPets.', false);
    if (submit) submit.disabled = false;
  }

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-fp-klaviyo-newsletter="true"]');
    if (!form || form.dataset.fpKlaviyoBypass === 'true') return;
    if (!form.reportValidity()) return;

    event.preventDefault();
    subscribe(form).catch(function () {
      setMessage(form, 'No pudimos conectar con Klaviyo. Intentaremos registrarte por Shopify.', true);
      nativeFallback(form);
    });
  });
})();
